import { get, post } from './http-calls';

export const getAllVmrsSubCategorys = async () => {
    let res = await get(`VMRSSubCategory`, { useAuthToken: true });
    return res;
};

export const getVmrsSubCategoryById = async (id) => {
    let res = await get(`VMRSSubCategory/${id}`, { useAuthToken: true });
    return res;
};

export const postVmrsSubCategoryData = async (data) => {
    let res = await post(`VMRSSubCategory`, data, { useAuthToken: true });
    return res;
};

export const getAllVmrsCategorys = async () => {
    let res = await get(`VMRSCategory`, { useAuthToken: true });
    return res;
};

export const getAllVMRSCategory = async () => {
    let res = await get(`VMRSCategory`, { useAuthToken: true });
    return res;
};

export const getVMRSCategoryById = async (id) => {
    let res = await get(`VMRSCategory/${id}`, { useAuthToken: true });
    return res;
};

export const postVMRSCategoryData = async (data) => {
    let res = await post(`VMRSCategory`, data, { useAuthToken: true });
    return res;
};

export const getVmrsCategoryDropDown = async () => {
    let res = await get(`VMRSCategory/screenDropdowns`, { useAuthToken: true });
    return res;
};

export const postEventDocs = async (data) => {
    let res = await post(`Eventdocs`, data, { useAuthToken: true });
    return res;
};

export const getAllEventDocs = async () => {
    let res = await get(`Eventdocs`, { useAuthToken: true });
    return res;
};

export const getAllScheduleEvents = async () => {
    let res = await get(`ScheduleEvents`, { useAuthToken: true });
    return res;
};
export const getScheduleEventsById = async (ID) => {
    let res = await get(`ScheduleEvents/${ID}`, { useAuthToken: true });
    return res;
};
export const getAllDropdowns = async () => {
    let res = await get(`ScheduleEvents/screenDropdowns`, { useAuthToken: true });
    return res;
};

export const postScheduleEvents = async (data) => {
    let res = await post(`ScheduleEvents`, data, { useAuthToken: true });
    return res;
};
